// src/search-core/FilterUiCommand.ts
/**
 * Команды для работы с фильтрами (namespace = "filter").
 */
var FilterUiCommand;
(function (FilterUiCommand) {
    /** Сбросить фильтры */
    FilterUiCommand["clearFilter"] = "clearFilter";
    /** Закрыть панель фильтров (для режима асайда) */
    FilterUiCommand["closeFilter"] = "closeFilter";
    /** Свернуть / развернуть группу фильтров */
    FilterUiCommand["toggleGroup"] = "toggleGroup";
})(FilterUiCommand || (FilterUiCommand = {}));

export { FilterUiCommand };
